import { render, staticRenderFns } from "./personal-details-bar.vue?vue&type=template&id=1a7a2fba&scoped=true&"
import script from "./personal-details-bar.vue?vue&type=script&lang=js&"
export * from "./personal-details-bar.vue?vue&type=script&lang=js&"
import style0 from "./personal-details-bar.vue?vue&type=style&index=0&id=1a7a2fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a2fba",
  null
  
)

export default component.exports